<template>
  <div>
    <div class="ratio ratio-16x9" ref="videoContainer">
      <div v-if="spinner" class="d-flex justify-content-center align-items-center w-100 h-100" style="z-index: -1">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>

    <div class="text-start">
      <button
        @click="continueVideo"
        v-if="!spinner && leftOffLastTime && enableReturn && !disableReturn"
        class="btn btn-primary text-white rounded-0 btn-sm"
      >{{ 'Resume playback' | translate }}</button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import playerjs from 'player.js'

export default {
  props: ['component'],
  data: () => ({
    player: null,
    leftOffLastTime: 0,
    enableReturn: 0,
    disableReturn: 0,
    spinner: 1,
  }),
  mounted() {
    if (this.bunny) {
      this.leftOffLastTime = localStorage.getItem(`video-${this.component.bunny_id}`)
      this.player = new playerjs.Player(this.createVideoIframe())

      this.player.on('ready', () => {
        this.spinner = 0
        this.setPlayerEvents()
      })
    }
  },
  destroyed() {
    this.disablePlayerEvents()
  },
  computed: {
    bunny() {
      if (this.component.bunny_id && _.includes([3, 4], this.component.bunny_status)) {
        return true
      }
      return false
    },
  },
  methods: {
    createVideoIframe() {
      const iframe = document.createElement('iframe')
      iframe.src = `https://iframe.mediadelivery.net/embed/25534/${this.component.bunny_id}?autoplay=false&preload=false`
      iframe.setAttribute('loading', 'lazy')
      iframe.setAttribute('allow', 'accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;')
      iframe.setAttribute('allowfullscreen', true)
      this.$refs.videoContainer.appendChild(iframe)
      return iframe
    },
    continueVideo() {
      this.player.setCurrentTime(this.leftOffLastTime - 3)
      this.disableReturn = 1
    },
    setPlayerEvents() {
      this.player.on('play', this.handlePlayEvent)
      this.player.on('pause', this.handlePause)
      this.player.on('ended', this.handleEnded)
      this.player.on('seeked', this.handleSeeked)
      this.player.on('timeupdate', this.handleTimeUpdate)
    },
    handlePlayEvent() {
      this.player.getDuration((value) => {
        if (value > 100) {
          this.enableReturn = 1
        }
      })
    },
    handlePause() {
      this.enableReturn = 0
    },
    handleEnded() {},
    handleSeeked() {},
    handleTimeUpdate(e) {
      localStorage.setItem(`video-${this.component.bunny_id}`, e.seconds)
    },
    disablePlayerEvents() {
      this.player.off('play')
      this.player.off('pause')
      this.player.off('ended')
      this.player.off('seeked')
      this.player.off('timeupdate')
    },
  },
}
</script>
